<template>
  <div>
    <template v-if="marker">
      <v-toolbar
        elevation="1"
        dark
        dense
        color="highlight"
        flat
        v-bind:class="
          $store.state.isOffline ? 'sticky' : 'sticky-toolbar-breadcrumb'
        "
      >
        <v-toolbar-title
          >{{ $t("marker") }} {{ marker !== null ? marker.number : "" }}
          {{ marker.label ? ` - ${marker.label}` : "" }}</v-toolbar-title
        >
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <template>
            <archivedReports :marker="marker"></archivedReports>
          </template>
        </v-toolbar-items>
        <v-toolbar-items v-if="marker.reports.length > 0">
          <v-btn icon disabled class="mr-2">
            <v-badge overlap :content="marker.reports.length" color="primary">
              <v-icon color="error">report_problem</v-icon>
            </v-badge>
          </v-btn>
        </v-toolbar-items>
        <can I="update" a="markers">
          <v-btn small depressed color="secondary" @click="lockBlueprint">{{
            $t("edit")
          }}</v-btn>
        </can>
        <!-- </v-toolbar-items> -->
      </v-toolbar>
      <div class="orange darken-1 text-center">
        <span class="white--text">{{ $t("inReadOnly") }}</span>
      </div>
      <v-expand-transition>
        <isLocked
          v-on:close="showLockedMessage = false"
          v-if="showLockedMessage"
          :blueprint="blueprint"
        ></isLocked>
      </v-expand-transition>
      <!-- <v-card flat > -->
      <v-layout
        class="mb-5"
        v-if="marker && blueprint && $store.state.productSolutions"
        wrap
      >
        <v-flex lg7 xs12>
          <v-container>
            <v-form ref="form" class="compact-form" v-model="valid">
              <v-card>
                <v-container grid-list-md text-xs-center>
                  <v-menu
                    transition="scale-transition"
                    origin="right top"
                    ref="menu1"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    lazy
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        outlined
                        dense
                        disabled
                        v-model="marker.date"
                        v-bind:label="$t('applicationDate')"
                        persistent-hint
                        prepend-icon="event"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="marker.date"
                      no-title
                    ></v-date-picker>
                  </v-menu>
                  <template v-if="marker.installer != null">
                    <small class="v-label theme--light">
                      <p class="mb-0 text-sm-left">{{ $t("installer") }}</p>
                    </small>
                    <p class="text-sm-left">
                      {{ marker.installer.firstname }}
                      {{ marker.installer.name }}
                    </p>
                  </template>

                  <v-select
                    :value="marker.status"
                    outlined
                    dense
                    :menu-props="{ bottom: true, offsetY: true }"
                    disabled
                    :label="$t('status')"
                    item-value="id"
                    :items="statusItems"
                  >
                    <template v-slot:item="{ item, index }">
                      <!-- <span v-html="item.name"/> -->
                      <v-icon :color="item.color">{{ item.icon }}</v-icon>
                      {{ item.name }}
                    </template>
                    <template v-slot:selection="{ item, index }">
                      <!-- <span v-html="item.name"/> -->
                      <v-icon :color="item.color">{{ item.icon }}</v-icon>
                      {{ item.name }}
                    </template>
                  </v-select>
                  <!-- </can> -->
                </v-container>
              </v-card>
              <div class="mb-3 mt-3">
                <transition name="flip" mode="out-in">
                  <solutionsList
                    v-on:open="openSolution"
                    readonly
                    key="'s'"
                    v-bind:marker="marker"
                    :blueprint="blueprint"
                  ></solutionsList>
                </transition>
              </div>
              <v-card>
                <v-container>
                  <v-textarea
                    disabled
                    outlined
                    v-model="marker.comments"
                    v-bind:label="$t('comments')"
                  ></v-textarea>
                </v-container>
              </v-card>
            </v-form>
          </v-container>
        </v-flex>
        <v-flex v-if="!$store.state.isMobile" lg5 xs12>
          <v-container>
            <zoomMarkup
              readonly
              v-bind:detailPage="true"
              v-bind:blueprint="blueprint"
            ></zoomMarkup>
          </v-container>
        </v-flex>
      </v-layout>
      <v-container fill-height v-else>
        <loading></loading>
      </v-container>
      <!-- </v-card> -->
      <div
        v-if="
          blueprint && blueprint.blueprintFile.content && $store.state.isMobile
        "
        outlined
        color="primary"
        class="floating-button"
      >
        <zoomMarkup
          ref="markup"
          v-bind:detailPage="true"
          readonly
          v-bind:blueprint="blueprint"
        ></zoomMarkup>
      </div>
      <savebeforeleave :dialog="saveDialog"></savebeforeleave>
    </template>
    <v-container fill-height v-else>
      <loading></loading>
    </v-container>
  </div>
</template>



<script>
import jwtdecode from "jwt-decode";
import uuid from "uuid";
import addQRCode from "@/components/pages/Markers/AddQRCode";
import zoomPicture from "@/components/pages/Markers/ZoomPicture";
import solutionsList from "@/components/pages/Markers/MarkerXSolutions/List";
import reports from "@/components/pages/Markers/Reports";
import archivedReports from "@/components/pages/Markers/archivedReports";
import zoomMarkup from "@/components/pages/Markers/ZoomMarkup";
import { serviceihub } from "@/services/service.ihub.js";
import { constants } from "crypto";
import { Promise, all } from "q";
import isLocked from "@/components/pages/Blueprints/IsLocked";

const _serviceIhub = new serviceihub();

export default {
  name: "markerDetails",
  components: {
    zoomPicture,
    addQRCode,
    solutionsList,
    zoomMarkup,
    reports,
    isLocked,
    archivedReports,
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.hasChanges) {
      this.$store.state.hasChanges = false;
      next();

      //     if (to.name !== "MarkerXSolutionDetails") {
      //       this.saveDialog = true;
      //       this.$store.state.hasChanges = false;
      //       this.to = to;
      //       next(false);
      //     } else {
      //       next();
      //     }
      //   }
      // } else {
      //   if (this.readonly) {
      //     next();
      //   } else {
      //     if (
      //       to.name != "BlueprintsDetails" &&
      //       to.name != "MarkerXSolutionDetails"
      //     ) {
      //       if (this.$can("update", "markers")) {
      //         this.$http
      //           .lockBlueprint(this.blueprint.id)
      //           .then(res => {
      //             if (to.name === "Login") {
      //               localStorage.removeItem("auth");
      //               localStorage.removeItem("user");
      //             }
      //             next();
      //           })
      //           .catch(err => {
      //             console.log(err);
      //           });
      //       } else {
      //         next();
      //       }
      //     } else {
      //       next();
      //     }
      //   }
    } else {
      next();
    }
  },
  props: {
    markerid: String,
    //marker: Object
  },
  data() {
    return {
      admin: false,
      dialog: false,
      // installers: null,
      attachment: null,
      loaded: false,
      marker: null,
      menu: false,
      valid: false,
      //productSolutions: "",
      blueprint: null,
      selectedFile: null,
      nameRules: [
        (v) => !!v || "Name is required",
        //v => v.length <= 25 || "Name must be less than 10 characters"
      ],
      isLoading: false,
      search: null,
      readonly: false,
      saveDialog: false,
      to: null,
      loadingText: "",
      showLockedMessage: false,
    };
  },
  computed: {
    isOffline() {
      return this.$store.state.isOffline;
    },
    statusItems() {
      return [
        {
          id: "0",
          name: this.$t("broken"),
          icon: "priority_high",
          color: "red",
          disabled: false,
        },
        {
          id: "1",
          name: this.$t("inProcess"),
          icon: "priority_high",
          color: "orange",
          disabled: true,
        },
        {
          id: "2",
          name: this.$t("approved"),
          icon: "check_circle",
          color: "success",
          disabled: false,
        },
      ];
    },
  },
  methods: {
    openSolution(mxs) {
      this.$router.push({
        name: "MarkerXSolutionDetails",
        params: {
          id: this.marker.id,
          markerXSolutionId: mxs.id,
          markerXSolution: mxs,
          marker: this.marker,
          blueprint: this.blueprint,
          readonly: true,
        },
      });
    },
    lockBlueprint() {
      this.$store.state.readyForOffline = false
      if (this.$can("update", "markers")) {
        if (
          this.blueprint.lockedByUserId ==
          parseInt(jwtdecode(localStorage.getItem("auth")).contactId)
        ) {
          this.$router.push({
            name: "EditMarkerDetails",
            params: { id: this.marker.id },
          });
        } else {
          this.$http
            .lockBlueprint(this.blueprint.id)
            .then((res) => {
              if (
                res.data.lockedByUserId ==
                parseInt(jwtdecode(localStorage.getItem("auth")).contactId)
              ) {
                this.$router.push({
                  name: "EditMarkerDetails",
                  params: { id: this.marker.id },
                });
              } else {
                this.showLockedMessage = true;
              }
            })
            .catch((err) => {
              console.log(err);
              this.$noty.error(this.$t("error"));
            });
        }
      }
    },
    makeBackButton() {
      this.$store.state.previous = {
        name: "BlueprintsDetails",
        id: this.blueprint.id,
        breadcrumb: this.$t("blueprint"),
      };
    },
    makeBreadcrumb() {
      this.$store.state.breadcrumb = [
        {
          name: this.$t("projects"),
          to: { name: "Projects" },
        },
        {
          name: this.blueprint.project,
          to: {
            name: "ProjectDetails",
            params: { id: this.blueprint.projectId },
          },
        },
        {
          name: this.blueprint.buildingComponent,
          to: {
            name: "BuildingComponentDetails",
            params: { id: this.blueprint.buildingComponentId },
          },
        },
        {
          name: this.blueprint.name,
          to: {
            name: "BlueprintsDetails",
            params: { id: this.blueprint.id },
          },
        },
        {
          name: `${this.$t("marker")} ${this.marker.number} ${
            this.marker.label ? " - " + this.marker.label : ""
          }`,
        },
      ];
    },
    getProductSolutions() {
      if (this.$store.state.productSolutions == null) {
        this.$http
          .getProductSolutions(true)
          .then((res) => {
            this.$store.state.productSolutions = res.data;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    async getAllAttributesAndSaveInStore() {
      if (this.$store.state.allAttributes == null) {
        try {
          let res = await this.$http.getAttributes(false, true);
          this.$store.state.allAttributes = res.data;
        } catch (err) {
          console.log(err);
        }
      }
    },
  },
  watch: {
    marker(n, o) {
      if (n != null || n != undefined) {
        if (n.installerId == null) {
          this.marker.installerId = parseInt(
            jwtdecode(localStorage.getItem("auth")).contactId
          );
        }
      }
    },
    blueprint(n, o) {
      if (n) {
        if (n.isArchived) {
          this.$router.push({
            name: "ArchivedBlueprintsDetails",
            params: { id: n.id },
          });
        }
      }
    },
    readonly() {},
  },
  created() {
    if (this.$store.state.isOffline) {
      alert("could not load marker, connect to internet");
      this.blueprint = this.$store.state.offline.offBlueprint;
      this.makeBackButton();
    } else {
      this.getAllAttributesAndSaveInStore();
      // this.marker = this.$route.params.marker;
      this.blueprint = this.$route.params.blueprint;
      // if (this.marker === undefined) {
      this.$http.getMarker(this.$route.params.id).then((res) => {
        this.marker = res.data;
        // this.$store.state.markers = [];
        this.$store.commit("AddAndSetUIelementsReadonly", res.data);
        this.$http
          .getBlueprint(this.marker.blueprintId)
          .then((res) => {
            this.blueprint = res.data;
            this.makeBackButton();
            this.makeBreadcrumb();
          })
          .catch((err) => console.log(err));
      });
      // } else {
      //   this.makeBackButton();
      //   this.makeBreadcrumb();
      //   if (this.$route.params.edit) {
      //     this.$nextTick(() => {
      //       this.lockBlueprint();
      //     });
      //   }
      // }
      this.getProductSolutions();
    }
  },
};
</script>

<style >
</style>


// WEBPACK FOOTER //
// src/views/markers/Details.vue